import React, { useEffect, useState } from "react";
import SectionOne from "./components/SectionOne";
import SectionMain from "./components/SectionMain";
import SectionTwo from "./components/SectionTwo";
import { useDispatch, useSelector } from "react-redux";
import FileUploadandSelect from "../../../components/admin/usable/fileuploader/FileUploadandSelect";
import { deleteFiles, viewAllFiles } from "../../../api/admin/filemanagerApi";
import {
  setAllFiles,
  setForFileManager,
} from "../../../redux/admin/fileManagerSlice";
import toast from "react-hot-toast";

const FileManager = () => {
  const [IsPropertyShown, setIsPropertyShown] = useState(false);
  const [Page, setPage] = useState(1);
  const [Limit, setLimit] = useState(22);
  const [Pagination, setPagination] = useState("");
  const [Search, setSearch] = useState("");

  const { showFileUploader, multiSelected, allFiles } = useSelector(
    (state) => state.file,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (showFileUploader === true) {
      viewAllFiles(dispatch, Page, Limit, setPagination, allFiles);
    } else {
      viewAllFiles(dispatch, Page, Limit, setPagination, allFiles);
    }
  }, [Page, Limit, showFileUploader]);
  useEffect(() => {
    dispatch(setForFileManager(true));

    return () => {
      dispatch(setForFileManager(false)); // component unmount হলে false হবে
    };
  }, []);
  useEffect(() => {
    if (Search.trim() === "") {
      viewAllFiles(dispatch, Page, Limit, setPagination, allFiles);
    } else {
      const result = allFiles.filter((file) =>
        file.fileName.toLowerCase().includes(Search.toLowerCase()),
      );
      dispatch(setAllFiles(result));
    }
  }, [Search]);
  const handleDelete = () => {
    if (multiSelected.length === 0) {
      toast.error("File is not selected");
    } else {
      deleteFiles(
        multiSelected,
        dispatch,
        Page,
        Limit,
        setPagination,
        allFiles,
      );
    }
  };
  return (
    <>
      {showFileUploader && <FileUploadandSelect />}
      <div className="space-y-4 overflow-hidden">
        <SectionOne
          Search={Search}
          setSearch={setSearch}
          handleDelete={handleDelete}
        />
        <div className="flex flex-wrap gap-x-5 overflow-hidden">
          <div className="flex-1">
            <SectionMain
              IsPropertyShown={IsPropertyShown}
              setIsPropertyShown={setIsPropertyShown}
              setPage={setPage}
              Page={Page}
              setLimit={setLimit}
              Pagination={Pagination}
            />
          </div>
          {IsPropertyShown === true && (
            <div>
              <SectionTwo />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FileManager;
